import { Form } from "@amzn/aquila-feedback-web-assets";
import type { FC } from "react";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { useGetAllInsghtsTabReportIssueForm } from "../../hooks/aquila/reportIssue/useGetReportIssueForm/useGetAllInsghtsTabReportIssueForm";
import { useSubmitReportIssueForm } from "../../hooks/aquila/reportIssue/useSubmitReportIssueForm/useSubmitReportIssueForm";
import { authStore } from "../../store/auth";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isSuccess } from "../../utils/api.utils";

interface AllInsightsReportIssueProps {
    onComponentReady?: (callback: {
        setIsReportIssueOpen: (isFeedbackFormOpen: boolean) => void;
    }) => void;
}

const InternalReportIssue: FC = ({
    onComponentReady,
}: AllInsightsReportIssueProps) => {
    const [aquilaConfig] = useStore(authStore, (state) => [
        state.settings.aquilaConfig,
    ]);
    const [
        formConfig,
        formConfigAsyncStatus,
        getFormConfigAsyncAction,
        updateFormConfig,
    ] = useGetAllInsghtsTabReportIssueForm({
        reportIssueFormConfig: aquilaConfig.allInsightsTabReportIssueConfig,
    });
    const [isReportIssueOpen, setIsReportIssueOpen] = useState(false);
    const [, createFeedbackAsyncAction] = useSubmitReportIssueForm({
        reportIssueFormConfig: aquilaConfig.allInsightsTabReportIssueConfig,
        trigger: AquilaReportIssueTriggerType.ALL_INSIGHTS_TAB,
    });

    const handleOnSubmit = (formData) => {
        setIsReportIssueOpen(false);
        void createFeedbackAsyncAction.execute(formData);
    };

    const handleOnCancel = () => {
        setIsReportIssueOpen(false);
    };

    useEffect(() => {
        if (aquilaConfig.allInsightsTabReportIssueConfig?.configId) {
            void getFormConfigAsyncAction.execute();
        }
    }, []);

    useEffect(() => {
        if (onComponentReady) {
            onComponentReady({
                setIsReportIssueOpen,
            });
        }
    }, [onComponentReady]);

    return isSuccess(formConfigAsyncStatus) && formConfig ? (
        <>
            {isReportIssueOpen && (
                <Form
                    {...formConfig}
                    configId={
                        aquilaConfig.allInsightsTabReportIssueConfig.configId
                    }
                    onSubmit={handleOnSubmit}
                    onCancel={handleOnCancel}
                    onFieldChange={updateFormConfig}
                    isOpen={isReportIssueOpen}
                />
            )}
        </>
    ) : (
        <></>
    );
};

export const AllInsightsReportIssue =
    React.memo<AllInsightsReportIssueProps>(InternalReportIssue);
